import { render, staticRenderFns } from "./editDiagnosis.vue?vue&type=template&id=1a75ea9e&scoped=true&"
import script from "./editDiagnosis.vue?vue&type=script&lang=js&"
export * from "./editDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./editDiagnosis.vue?vue&type=style&index=0&id=1a75ea9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a75ea9e",
  null
  
)

export default component.exports